// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"c8617428","164":"e9eb5b53","417":"34aa21f4","506":"7e8588a2","791":"d5334354","903":"60a4cb49","909":"fb6eb84f"}[chunkId] + ".chunk.js";
};